const loaderTemplate = require('./view/loader.handlebars');

const LOADER_WRAPPER_SELECTOR: string = '[data-loader-wrapper]';

export class LoaderUI {
  private $base: JQuery;

  public constructor() {
    this.render();
  }
  public render(active: boolean = false) {
    $(LOADER_WRAPPER_SELECTOR).html(loaderTemplate({active: active}));
  }
}
